import axios from 'axios';
import setAuthToken from '../utils/setAuthToken'
import jwt_decode from 'jwt-decode';
import { SET_FACULTY, SET_ERRORS, SET_FLAG, SET_ERRORS_HELPER } from '../actionTypes'

const setFaculty = (data) => {
    return {
        type: SET_FACULTY,
        payload: data
    }
}
let apiUrl = "http://localhost:5000";

if (process.env.REACT_APP_VERCEL_API) {
    apiUrl = `${process.env.REACT_APP_VERCEL_API}`;
}

const fetchStudentsHelper = (data) => {
    return {
        type: "FETCH_STUDENTS",
        payload: data
    }
}
const fetchStudentsMarkHelper = (data) => {
    return {
        type: "FETCH_STUDENTS_MARK",
        payload: data
    }
}
const facultyTimeTableHelper = (data) => {
    return {
        type: "GET_ALL_TIMETABLE",
        payload: data
    }
}
const subjectCodeListHelper = (data) => {
    return {
        type: "GET_SUBJECTCODE_LIST",
        payload: data
    }
}
const studentsMarksListHelper = (data) => {
    return {
        type: "GET_STUDENTMARKS_LIST",
        payload: data
    }
}
const subjectFacultyHelper = (data) => {
    return {
        type: "GET_SUBJECTFACULTY_LIST",
        payload: data
    }
}
const AssignmentsListHelper = (data) => {
    return {
        type: "GET_ASSIGNMENTS_LIST",
        payload: data
    }
}
const studentMarks = (data) => {
    return {
        type: "GET_STUDENTMARKS",
        payload: data
    }
}

const facultyGetAllStudentHelper = (data) => {
    return {
        type: "GET_ALL_STUDENT",
        payload: data
    }
}
const fetchStudentsAttendenceHelper = (data) => {
    return {
        type: "GET_ALL_STUDENT_ATTENDENCE",
        payload: data
    }
}
const fetchfetchDailyReportHelper = (data) => {
    return {
        type: "GET_DAILY_REPORT",
        payload: data
    }
}

const getSubjctsHelper = (data) => {
    return {
        type: "GET_SUBJECTS",
        payload: data
    }
}
const facultyUpdateProfileFlag = (data) => {
    return {
        type: "FACULTY_UPDATE_PROFILE_FLAG",
        payload: data
    }
}
const facultyAddSubjectFlag = (data) => {
    return {
        type: "FACULTY_ADD_SUBJECT_FLAG",
        payload: data
    }
}
export const facultyLogin = (facultyCredential) => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Post',
                url: apiUrl  + "/api/faculty/login",
                data: facultyCredential
            })
            const { token } = data;
            // Set token to local Storage
            localStorage.setItem('facultyJwtToken', token);
            // Set token to Auth header
            setAuthToken(token);
            // Decode token to get user data
            const decoded = jwt_decode(token);
            // Set current user
            dispatch(setFaculty(decoded))
        }
        catch (err) {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        }
    }
}
export const facultyGetAllStudents = (department) => {
    return async (dispatch) => {
        try {
            console.log(department)
            const { data } = await axios({
                method: 'Get',
                url: apiUrl + "/api/faculty/getStudents",
                params: { department: department.department }
            })
            dispatch(facultyGetAllStudentHelper(data.result))
        }
        catch (err) {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        }
    }
}
export const fetchStudentsAttendence = (department, year, section, semester, date) => {
    return async (dispatch) => {
        try {
            const { data } = await axios.get(`${apiUrl}/api/faculty/getStudentsAttendence`, {
                params: { department, year, section, semester, date }
            });
            dispatch(fetchStudentsAttendenceHelper(data));
        } catch (err) {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            });
        }
    };
};
export const fetchDailyReport = (department, year, section, semester, date) => {
    return async (dispatch) => {
        try {
            const { data } = await axios.post(apiUrl + "/api/faculty/getDailyReports", {
                department, year, section, semester, date
            });
            console.log(data)
            dispatch(fetchfetchDailyReportHelper(data));   
        } catch (err) {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            });
        }
    };
};
export const facultyTimeTable = (department) => {
    return async (dispatch) => {
        try {
            console.log(department)
            const { data } = await axios({
                method: 'Get',
                url: apiUrl  + "/api/faculty/facultyTimeTable",
                params: { department: department.department }
            })
            dispatch(facultyTimeTableHelper(data))
        }
        catch (err) {
            console.log("Error in sending message", err.message)
        }
    }
}
export const facultyCreateTt = (timetableData) => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Post',
                url: apiUrl  + "/api/faculty/facultyCreateTt",
                data: timetableData
            })
            alert("TimeTable Created Successfully")
        }
        catch (err) {
            console.log("Error in sending message", err.message)
        }
    }
}
export const facultyUpdateTt = (timetableId,timetableData) => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Put',
                url: apiUrl  + `/api/faculty/facultyUpdateTt/${timetableId}`,
                data: timetableData
            })
            console.log(timetableId,timetableData);
            alert("TimeTable Updated Successfully")
        }
        catch (err) {
            console.log("Error in sending message", err.message)
        }
    }
}
export const facultyUpdatePassword = (passwordData) => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Post',
                url: apiUrl  + "/api/faculty/updatePassword",
                data: passwordData
            })
            alert("Password Updated Successfully")
        }
        catch (err) {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        }
    }
}
export const fetchStudents = (department, year, section, semester) => {
    return async (dispatch) => {
        try {
            console.log(department, year, section, semester)
            const { data } = await axios({
                method: 'Post',
                url: apiUrl  + "/api/faculty/fetchStudents",
                data: { department, year, section, semester}
            })
            dispatch(fetchStudentsHelper(data.result))
            dispatch(subjectCodeListHelper(data))   
        }
        catch (err) {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        }
    }
}
export const fetchStudentsMarks = (department, year, section, semester) => {
    return async (dispatch) => {
        try {
            console.log(department, year, section, semester)
            const { data } = await axios({
                method: 'Post',
                url: apiUrl  + "/api/faculty/fetchStudentsMarks",
                data: { department, year, section, semester}

            })
            // dispatch(fetchStudentsMarkHelper(data.result))
            dispatch(studentsMarksListHelper(data))   
        }
        catch (err) {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        }
    }
}
export const fetchSubjectFaculty = (department, year, section, semester) => {
    return async (dispatch) => {
        try {
            console.log(department, year, section, semester)
            const { data } = await axios({
                method: 'Post',
                url: apiUrl  + "/api/faculty/fetchSubjectFaculty",
                data: { department, year, section, semester}

            })
            console.log(data)
            dispatch(subjectFacultyHelper(data))   
        }
        catch (err) {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        }
    }
}
export const getStudentMarks = (subjectCode, exam, department, section, semester, year) => {
    return async (dispatch) => {
        try {
            console.log(subjectCode, exam, department, section, semester, year)
            const { data } = await axios({
                method: 'Post',
                url: apiUrl  + "/api/faculty/getStudentMarks",
                data: { subjectCode, exam, department, section, semester, year}
            })
            console.log(data)
            dispatch(studentMarks(data))   
        }
        catch (err) {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        }
    }
}
export const facultyUpdate = (updatedData) => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Post',
                url: apiUrl  + `/api/faculty/updateProfile`,
                data: updatedData
            })
            dispatch(facultyUpdateProfileFlag(true))
        }
        catch (err) {
            console.log("Error in sending message", err.message)
        }
    }
}
export const markAttendence =(sattendanceData) => {
    return async (dispatch) => {
        try {
            await axios({
                method: 'post',
                url: apiUrl + "/api/faculty/markAttendance",
                data: sattendanceData
            });

            alert("Attendance has been marked successfully");
            dispatch({
                type: "HELPER",
                payload: true,
            });
        } catch (err) {
            console.log("Error in marking attendance, faculty action", err.message);

            if (err.response && err.response.status === 400) {
                alert("Error: " + err.response.data.message);
            } else {
                alert("Error in marking attendance. Please try again later.");
            }
        }
    };
}
export const addDailyReport = (dailyReport) => {
    return async (dispatch) => {
        try {
            await axios.post(apiUrl + "/api/faculty/dailyReports", dailyReport);

            alert("Daily Report has been marked successfully");
            dispatch({
                type: "HELPER",
                payload: true,
            });
        } catch (err) {
            console.log("Error in marking Daily Report, faculty action", err.response);

            if (err.response && err.response.status === 400) {
                alert("Error: " + err.response.data.message || "Invalid data submitted.");
            } else {
                alert("Error in marking Daily Report. Please try again later.");
            }
        }
    };
};

export const uploadMarks = (subjectCode, exam, totalMarks, marks, department, section ,semester ) => {
    return async (dispatch) => {
        try {
            await axios({
                method: 'Post',
                url: apiUrl  + "/api/faculty/uploadMarks",
                data: {
                    subjectCode, exam, totalMarks, marks, department, section ,semester
                    }
            })
            alert("Mark uploaded successfully")
            dispatch({
                type: "HELPER",
                payload: true
            })
           
        }
        catch (err) {
            dispatch({
                type: SET_ERRORS_HELPER,
                payload: err.response.data
            })
        }
    }
}
export const facultyGetAllSubjects = (department) => {
    return async (dispatch) => {
        try {
            console.log(department)
            const { data } = await axios({
                method: 'GET',
                url: apiUrl + "/api/faculty/getSubjects",
                params: { department: department.department } // Correctly send department as a query parameter
              });
              
            dispatch(getSubjctsHelper(data))
        }
        catch (err) {
            console.log("Error in getting all subjects", err.message)
        }
    }
}
export const facultyAddSubject = (subjectCredential) => {
    return async (dispatch) => {
        try {
            console.log(subjectCredential)
            const { data } = await axios({
                method: 'Post',
                url: apiUrl + "/api/faculty/addSubject",
                data: subjectCredential
            })
            dispatch(facultyAddSubjectFlag(true))
            alert("Subject Added Successfully")
        }
        catch (err) {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        }
    }
}
export const setFacultyUser = data => {
    return {
        type: SET_FACULTY,
        payload: data
    };
}
export const createAssignment = (facultyAssignment) => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Post',
                url: apiUrl + "/api/faculty/facultycreateAssignment",
                data: facultyAssignment
            })
            alert("Assignment create successfully")
        }
        catch (err) {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        }
    }
}
export const uploadAssignmentMark = (assignmentId, studentId, mark) => {
    return async (dispatch) => {
        try {
            console.log(assignmentId, studentId, mark);
            const { data } = await axios({
              method: 'post',  // Corrected the method to 'post'
              url: apiUrl + "/api/faculty/uploadAssignmentMark",
              data: { assignmentId, studentId, mark}  // Pass data as an object
            });
      
            alert("Mark upload Successfully");
          } catch (err) {
            dispatch({
              type: SET_ERRORS,
              payload: err.response.data
            });
          }
    }
}
export const fetchAssignment = (department,semester) => {
    return async (dispatch) => {
        try {
            const { data } = await axios({
                method: 'Post',
                url: apiUrl + "/api/faculty/fetchAssignment",
                data: { department, semester }
            });
            
            // Assuming the assignments are available in data.assignments
            const assignments = data.assignments;
            console.log(assignments)

            // Dispatch the action with the fetched assignments
            dispatch(AssignmentsListHelper(assignments));
        } catch (err) {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            });
        }
    };
};
export const facultyLogout = () =>
    (dispatch) => {
        // Remove token from localStorage
        localStorage.removeItem('facultyJwtToken');
        // Remove auth header for future requests
        setAuthToken(false);
        // Set current user to {} which will set isAuthenticated to false
        dispatch(setFaculty({}));
};
